import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import CampaignStatusForm from "routes/campaign_status/components/CampaignStatusForm";

const HEADER = "New Campaign Status";

const NewCampaignStatusModal = ({ fetchStatuses }) => {
  const [open, setOpen] = useState(false);

  const handleSuccess = () => {
    setOpen(false);
    fetchStatuses();
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger render={<Button size="sm">{HEADER}</Button>} />
      <DialogContent>
        <DialogTitle>{HEADER}</DialogTitle>
        <CampaignStatusForm onSuccess={handleSuccess} submitButtonText="Add" />
      </DialogContent>
    </Dialog>
  );
};

export default NewCampaignStatusModal;
